import React from 'react';
import { handleScroll } from '~/utils/helpers';

const NavHeaderMobile = ({ location, menu_data, handleToggle }) => {
  function handleScrollAndToggle(e, href) {
    const currentHref = href ? href : '#';
    if (currentHref?.startsWith('#') && currentHref !== '#') {
      handleScroll(e, currentHref);
      handleToggle();
    }
  }
  return (
    <ul className='menu-mobile'>
      {menu_data?.menu_items.map((data, index) => {
        let submenuItemsLvl1;
        let levelsNum = 0;

        // Submenu - Level 1
        if (data.submenu_level_1 && data.submenu_level_1.length > 0) {
          levelsNum = 1;

          submenuItemsLvl1 = data.submenu_level_1.map(
            (submenuDataLvl1, index) => {
              let submenuItemsLvl2;
              let hasSubmenuLvl2 = false;
              if (
                submenuDataLvl1.submenu_level_2 &&
                submenuDataLvl1.submenu_level_2.length > 0
              ) {
                levelsNum = 2;
                hasSubmenuLvl2 = true;

                submenuItemsLvl2 = submenuDataLvl1.submenu_level_2.map(
                  (submenuDataLvl2, index) => {
                    let submenuItemsLvl3;
                    let hasSubmenuLvl3 = false;

                    if (
                      submenuDataLvl2.submenu_level_3 &&
                      submenuDataLvl2.submenu_level_3.length > 0
                    ) {
                      levelsNum = 3;
                      hasSubmenuLvl3 = true;

                      submenuItemsLvl3 = submenuDataLvl2.submenu_level_3.map(
                        (submenuDataLvl3, index) => {
                          return (
                            <li
                              key={index}
                              className={`item-level-3${submenuDataLvl3.class_name ? ' ' + submenuDataLvl3.class_name : ''} ${submenuDataLvl3.cta_style ? 'cta-style' : ''} ${index === 0 ? 'is-active' : ''}`}
                            >
                              <a
                                href={
                                  submenuDataLvl3.url
                                    ? submenuDataLvl3.url
                                    : '#'
                                }
                                onClick={e =>
                                  handleScrollAndToggle(e, submenuDataLvl3.url)
                                }
                              >
                                {submenuDataLvl3.icon && (
                                  <div className='icon'>
                                    <img
                                      src={submenuDataLvl3.icon}
                                      alt={submenuDataLvl3.title}
                                      title={submenuDataLvl3.title}
                                    />
                                  </div>
                                )}
                                <div className='item-wr'>
                                  <div className='mtitle'>
                                    {submenuDataLvl3.title}
                                  </div>
                                  {submenuDataLvl3.description && (
                                    <p>{submenuDataLvl3.description}</p>
                                  )}
                                </div>
                              </a>
                            </li>
                          );
                        }
                      );
                    }

                    return (
                      <li
                        key={index}
                        className={`item-level-2${submenuDataLvl2.class_name ? ' ' + submenuDataLvl2.class_name : ''} ${submenuDataLvl2.cta_style ? 'cta-style' : ''} ${hasSubmenuLvl3 ? 'has-submenu' : ''} ${index === 0 ? 'is-active' : ''}`}
                      >
                        <a
                          href={submenuDataLvl2.url ? submenuDataLvl2.url : '#'}
                          onClick={e =>
                            handleScrollAndToggle(e, submenuDataLvl2.url)
                          }
                        >
                          {submenuDataLvl2.icon && (
                            <div className='icon'>
                              <img
                                src={submenuDataLvl2.icon}
                                alt={submenuDataLvl2.title}
                                title={submenuDataLvl2.title}
                              />
                            </div>
                          )}
                          <div className='item-wr'>
                            <div className='mtitle'>
                              {submenuDataLvl2.title}
                            </div>
                            {submenuDataLvl2.description && (
                              <p>{submenuDataLvl2.description}</p>
                            )}
                          </div>
                        </a>
                        {submenuItemsLvl3 && (
                          <ul className='menu-level-3'>
                            <li className='submenu-title'>
                              {submenuDataLvl2.title}
                            </li>
                            {submenuItemsLvl3}
                          </ul>
                        )}
                      </li>
                    );
                  }
                );
              }

              return (
                <li
                  key={index}
                  className={`item-level-1${submenuDataLvl1.menu_class_name ? ' ' + submenuDataLvl1.menu_class_name : ''} ${submenuDataLvl1.cta_style ? 'cta-style' : ''} ${hasSubmenuLvl2 ? 'has-submenu' : ''} ${index === 0 ? 'is-active' : ''}`}
                >
                  <a
                    href={
                      submenuDataLvl1.submenu_url
                        ? submenuDataLvl1.submenu_url
                        : '#'
                    }
                    onClick={e =>
                      handleScrollAndToggle(e, submenuDataLvl1.submenu_url)
                    }
                  >
                    {submenuDataLvl1.submenu_icon && (
                      <div className='icon'>
                        <img
                          src={submenuDataLvl1.submenu_icon}
                          alt={submenuDataLvl1.submenu_title}
                          title={submenuDataLvl1.submenu_title}
                        />
                      </div>
                    )}
                    <div className='item-wr'>
                      <div className='mtitle'>
                        {submenuDataLvl1.submenu_title}
                      </div>
                      {submenuDataLvl1.submenu_description && (
                        <p>{submenuDataLvl1.submenu_description}</p>
                      )}
                    </div>
                  </a>
                  {submenuItemsLvl2 && (
                    <ul className='menu-level-2'>
                      <li className='submenu-title'>
                        {submenuDataLvl1.submenu_title}
                      </li>
                      {submenuItemsLvl2}
                    </ul>
                  )}
                </li>
              );
            }
          );

          return (
            <li
              key={index}
              className={`has-submenu lvl-${levelsNum} ${data.menu_class_name ? ' ' + data.menu_class_name : ''} ${data.footer.text ? 'has-footer' : ''}`}
            >
              <a href='#'>
                {data.menu_title} <i className='fas fa-chevron-down'></i>
              </a>
              <ul className={`menu-level-1`}>
                <li className='submenu-title'>{data.menu_title}</li>
                {submenuItemsLvl1}
                {data.footer.text && (
                  <li className='submenu-footer'>
                    <div className='left'>{data.footer.text}</div>
                    <div className='right'>
                      <a href={data.footer.cta_url}>{data.footer.cta_text}</a>
                    </div>
                  </li>
                )}
              </ul>
            </li>
          );
        }

        return (
          <li
            key={index}
            className={data.menu_class_name}
          >
            <a
              href={data.menu_url ? data.menu_url : '#'}
              onClick={e => handleScrollAndToggle(e, data.menu_url)}
            >
              {data.menu_title}
            </a>
          </li>
        );
      })}
    </ul>
  );
};

export default NavHeaderMobile;
